import React, { FC } from "react";

interface FooterProps {}

const Footer: FC<FooterProps> = () => <div className="bg-slate-700"></div>;

export default Footer;
